import { InjectionToken } from '@angular/core';

export const REFERRER_MODULE_CONFIG = new InjectionToken('REFERRER_MODULE_CONFIG');

export interface IReferrerModuleConfig {
  queryParameters: string[];
  storageKey: string;
}
